// angular imports
import { Component, Input, SimpleChanges, OnChanges } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
    selector: 'app-workflow-invoice-viewer',
    templateUrl: './workflow-invoice-viewer.component.html',
    styleUrls: ['./workflow-invoice-viewer.component.scss']
})
export class WorkflowInvoiceViewerComponent implements OnChanges {
    @Input() source: string = null;
    @Input() loader = true;

    pdfSource: SafeResourceUrl = null;

    constructor(private readonly sanitizer: DomSanitizer) {}

    ngOnChanges(changes: SimpleChanges) {
        if (changes.source) {
            if (changes.source.currentValue) {
                this.source = changes.source.currentValue;
                this.pdfSource = this.sanitizer.bypassSecurityTrustResourceUrl(this.source);
            } else {
                this.pdfSource = null;
            }
        }

        if (changes.loader) {
            this.loader = changes.loader.currentValue;
        }
    }
}
